// @flow

import duplicateEstimateItem from '../../../Services/duplicateEstimateItem';
import type { DuplicateEstimateItemParams } from '../../../types';

export default (params: DuplicateEstimateItemParams) => async (dispatch: Function) => dispatch(duplicateEstimateItem(params))